import { MainLayout } from "@/shared/layouts/MainLayout";
import { TermsAndConditions } from "./ui/TermsAndConditions";
import { Header } from "@/pages/MainPage/ui/Header";
import { Footer } from "@/pages/MainPage/ui/Footer";

export const TermsAndConditionsPage = () => {
    return (
        <MainLayout header={<Header />} footer={<Footer />}>
            <TermsAndConditions />
        </MainLayout>
    );
};
